function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutomateLicence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m30 41-4 4h-4l-4-4V21h12v8l-2 2 2 2v2l-2 2 2 2z",
    style: {
      fill: "#ffa000"
    },
    transform: "matrix(.83333 0 0 1 5.13 .288)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 7.8c-.5-1.8-2-3.1-3.7-3.6C31.899 3.7 28.2 3 24 3c-4.2 0-7.898.7-10.3 1.2C12 4.7 10.5 6 10 7.8c-.5 1.7-1 4.098-1 6.7 0 2.602.5 5 1 6.7.5 1.8 1.898 3.1 3.7 3.5 2.402.6 6.1 1.3 10.3 1.3 4.2 0 7.898-.7 10.3-1.2 1.802-.402 3.2-1.8 3.7-3.5.5-1.698 1-4.1 1-6.698 0-2.704-.5-5.102-1-6.801ZM29 13H19c-1.102 0-2-.898-2-2V9c0-.602 3.102-1 7-1s7 .398 7 1v2c0 1.102-.898 2-2 2z",
    style: {
      fill: "#ffa000"
    },
    transform: "matrix(.83333 0 0 1 5.13 .288)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 26h2v19h-2z",
    style: {
      fill: "#d68600"
    },
    transform: "matrix(.83333 0 0 1 5.13 .288)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomateLicence);
export default __webpack_public_path__ + "static/media/automateLicence.45d7797e41e9a7e464de33d1fcd324e5.svg";
export { ForwardRef as ReactComponent };